import { AnglePoints } from "../../types/Interface";
import calcAngles from "../math/calcAngles";
import generateAngle from "./generateAngle";


export function generateAngles(p: AnglePoints, clockwise: boolean,) {
  const { startRadian, endRadian } = calcAngles(p.curr, p.prev, p.next);
  const degree = generateAngle({ startRadian, endRadian }, clockwise, false);
  return {
    startRadian,
    endRadian,
    degree
  }
}